import { ChemicalElementDto } from './chemical-element.dto';

export class ChemicalElement {
    readonly id: string;
    readonly symbol: string;
    readonly name: string;

    constructor(dto: ChemicalElementDto) {
        this.id = dto.id;
        this.symbol = dto.symbol;
        this.name = dto.name ?? '';
    }
}
